var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var ViewHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\ndisplay: flex;\nflex-flow: row;\nalign-items: center;\npadding: .5rem 1rem;\njustify-content: space-between;\n"], ["\ndisplay: flex;\nflex-flow: row;\nalign-items: center;\npadding: .5rem 1rem;\njustify-content: space-between;\n"])));
export default ViewHeader;
var templateObject_1;
